import { CreateInvoiceDto, InvoiceDto, INVOICE_TYPE_SUPPLIER, UpdateInvoiceResource } from '@sr/dto';
import { FormTools, VALIDATION_REQUIRED_FIELD } from 'utils/form-tools';
import { FormikErrors } from 'formik';
import { sharedEmptyValues, sharedFromDto, sharedToDto, sharedValidate, SharedFormData as BaseFormData } from 'entities/invoice/shared-invoice.form';

export type FormData = BaseFormData & {
  contractId: number | '';
};

export const formTools: FormTools<InvoiceDto, CreateInvoiceDto, UpdateInvoiceResource, FormData> = {
  toUpdateDto: function (id: number, formData: FormData) {
    throw new Error('Function not implemented.');
  },

  toCreateDto: (formData: FormData): CreateInvoiceDto => {
    const dto = sharedToDto(formData);
    dto.contractId = Number(formData.contractId);
    dto.invoiceNumber = formData.invoiceNumber;
    dto.type = INVOICE_TYPE_SUPPLIER;
    if (formData.sellerCompanyId) {
      dto.sellerCompanyId = formData.sellerCompanyId;
    }
    return dto;
  },

  fromDto: (dto: InvoiceDto): FormData => ({
    ...sharedFromDto(dto),
    contractId: dto.contractId
  }),

  validate: (values: FormData): FormikErrors<FormData> => {
    let validationResult = sharedValidate(values) as FormikErrors<FormData>;
    if (!values.invoiceNumber) validationResult.invoiceNumber = VALIDATION_REQUIRED_FIELD;
    if (!values.contractId) validationResult.contractId = VALIDATION_REQUIRED_FIELD;
    if (!values.managerId) validationResult.managerId = VALIDATION_REQUIRED_FIELD;

    return validationResult;
  },

  emptyValues: () => ({
    ...sharedEmptyValues(),
    contractId: ''
  })
};
